export const getAllDocumentsConfig = data => ({
  static_data: data,
  backend_querying: false,
  header: {
    title: "title_all_documents",
  },
  columns: [
    {
      db_field: "filename",
      title: "label_filename",
      type: "text",
      width: "35%",
    },
    {
      db_field: "datum",
      title: "label_date",
      type: "date",
      sortable: true,
      width: "10%",
    },
    {
      db_field: "doctype",
      title: "label_doctype",
      type: "text",
      sortable: true,
      width: "20%",
    },
    {
      db_field: "id",
      title: "title_id",
      type: "text",
      width: "30%",
    },
    {
      type: "actions",
      width: "5%",
      actions: [
        {
          icon: "download-assignment",
          showWhen: ({ document_download_link }) =>
            Boolean(document_download_link),
          onClick: ({ document_download_link }) =>
            window.open(document_download_link, "_blank"),
        },
      ],
    },
  ],
});

export const getActivityLogsConfig = data => ({
  static_data: data,
  backend_querying: false,
  header: {},
  columns: [
    {
      db_field: "id",
      title: "title_id",
      type: "text",
      width: "10%",
    },
    {
      db_field: "customer",
      title: "label_customer",
      type: "text",
      width: "10%",
    },
    {
      db_field: "created_at",
      title: "label_created_at",
      type: "date",
    },
    {
      db_field: "type",
      title: "type",
      type: "text",
      width: "10%",
    },
    {
      db_field: "model",
      title: "label_model",
      type: "text",
      width: "10%",
    },
    {
      type: "actions",
      width: "5%",
      actions: [
        {
          icon: "menu-report",
          type: "button",
          onClick: () => {},
        },
      ],
    },
  ],
});
